export function stringToBytes32(inputString: string): string {
  // Ensure the input string is not longer than 32 characters
  if (inputString.length > 32) {
    throw new Error("Input string is too long for bytes32");
  }

  // Pad the string with zeros to make it 32 bytes long
  const zeroPadding = "0".repeat(64); // 64 characters to represent 32 bytes
  const paddedString = (inputString + zeroPadding).slice(0, 64);

  // Convert the padded string to bytes32 format
  const bytes32 = "0x" + paddedString;

  return bytes32;
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (loadEvent) {
      // Check if loadEvent.target is not null and is an instance of FileReader
      if (loadEvent.target instanceof FileReader) {
        const base64String = loadEvent.target.result;
        resolve(base64String as string); // Resolve the promise with the base64 string
      } else {
        reject("Failed to read file");
      }
    };
    reader.onerror = reject; // Reject the promise on read error
    reader.readAsDataURL(file); // Read the file as a Data URL (Base64)
  });
}

/**
 * Converts a Base64 string to a File object.
 * @param base64String The Base64 string to convert.
 * @param fileName The name you want to give to the new file.
 * @param mimeType The MIME type of the file. Example: 'image/jpeg'.
 * @returns {File} The File object created from the Base64 string.
 */
export function base64StringToFile(
  base64String: string,
  fileName: string = "image.jpg",
  mimeType: string = "image/jpeg"
) {
  // Decode the Base64 string
  const byteString = atob(base64String.split(",")[1]);

  // Create a Uint8Array from the decoded string
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }

  // Create a Blob from the Uint8Array
  const blob = new Blob([intArray], { type: mimeType });

  // Create a File from the Blob
  const file = new File([blob], fileName, { type: mimeType });

  return file;
}
